import { z } from 'zod';

export const integrationSchema = z.object({
  integrationId: z.string(),
  service: z.preprocess(
    (v) => String(v).toLowerCase(),
    z.enum([
      'confluence',
      'custom_unstructured',
      'facebook_ads',
      'facebook_page',
      'google_ads',
      'google_analytics',
      'google_bigquery',
      'github',
      'google_drive',
      'mixpanel',
      'notion',
      'shopify',
      'slack',
    ]),
  ),
  createdAt: z.string(),
  name: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
});

export interface Integration {
  integrationId: string;
  service:
    | 'confluence'
    | 'custom_unstructured'
    | 'facebook_ads'
    | 'facebook_page'
    | 'google_ads'
    | 'google_analytics'
    | 'google_bigquery'
    | 'github'
    | 'google_drive'
    | 'mixpanel'
    | 'notion'
    | 'shopify'
    | 'slack';
  createdAt: string;
  name?: string | null;
  description?: string | null;
  workspaceId?: string | null;
}

export const accountSchema = z.object({
  accountId: z.string(),
  slug: z.string(),
  name: z.string(),
  timezone: z.string().nullable().optional(),
  isOnboarded: z.boolean(),
  features: z.record(z.string(), z.union([z.boolean(), z.array(z.string())])).optional(),
  integrations: z.array(integrationSchema),
  connections: z.array(z.object({ type: z.string() })).optional(),
  pinnedExplorationIds: z.array(z.string()).optional(),
  me: z.object({
    pinnedExplorationIds: z.array(z.string()).optional(),
    role: z.object({
      permissions: z.array(z.object({ permissionId: z.string() })),
    }),
  }),
});

export interface Account {
  accountId: string;
  slug: string;
  name: string;
  timezone?: string | null;
  isOnboarded: boolean;
  features?: Record<string, boolean | string[]>;
  integrations: Integration[];
  connections?: { type: string }[];
  pinnedExplorationIds?: string[];
  me: { pinnedExplorationIds?: string[]; role: { permissions: { permissionId: string }[] } };
}
